module.exports = __webpack_public_path__ + "static/media/bag.86728fdf.atlas";